<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M6.35159 8.7516c.22503-.22497.5302-.35134.8484-.35134.31819 0 .62336.12637.8484.35134L12 12.7032l3.9516-3.9516c.1107-.11461.2431-.20603.3895-.26892s.3039-.096.4632-.09738c.1593-.00139.3174.02898.4648.08931.1475.06034.2815.14944.3942.26212.1126.11267.2017.24665.2621.39412.0603.14748.0907.3055.0893.46483-.0014.15934-.0345.3168-.0974.46322-.0629.1464-.1543.2788-.2689.3895l-4.8 4.8c-.225.225-.5302.3513-.8484.3513-.3182 0-.6234-.1263-.8484-.3513l-4.80001-4.8c-.22497-.225-.35135-.5302-.35135-.8484 0-.3182.12638-.62337.35135-.8484Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M4.29289 8.29289c.39053-.39052 1.02369-.39052 1.41422 0L12 14.5858l6.2929-6.29291c.3905-.39052 1.0237-.39052 1.4142 0 .3905.39053.3905 1.02369 0 1.41422l-7 6.99999c-.3905.3905-1.0237.3905-1.4142 0L4.29289 9.70711c-.39052-.39053-.39052-1.02369 0-1.41422Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
